var auth = require('@ycgame/auth').auth;
var authDialog = require('@ycgame/auth-components').authDialog;
var layer = require("./layer/layer");

$(function () {

    // 登录
    authDialog.showVendors();
    $(".head-window-btn, .lv1-reg-btn, .lv1 input, .lv3 input, .lv4 input, .lv5 input").click(function (e) {
        alert("活动已结束！")
        // if (!auth.member) {
        //     $.ycUserDialogOpen();
        //     e.stopImmediatePropagation();
        // }
    });
    auth.bind(auth.EVENTS.LOGOUT, function () {
        location.reload();
        sessionStorage.removeItem('markId');
    });

    auth.checkLogin();

    auth.bind(auth.EVENTS.LOGIN, function () {
        role();
        accomplishDay();
        $(".lv1-reg-btn").hide();
        $(".login, .reg-success").show();
        $(".lv1-type1-hero input").click(function () {
            $(".lv1-type1-hero input").attr('disabled',true);
            var heroId = $(this).attr("data-id");
            heroEnlist(heroId);
        });
        $(".lv1-type2-hero input").click(function () {
            $(".lv1-type2-hero input").attr('disabled',true);
            var skinId = $(this).attr("data-id");
            skinEnlist(skinId);
        });
        $(".lv3-type1-hero input").click(function () {
            $(".lv3-type1-hero input").attr('disabled',true);
            var heroId = $(this).attr("data-id");
            accomplishHero(heroId);
        });
        $(".lv4-type1-hero input, .lv4-type2-hero input").click(function () {
            $(".lv4-type1-hero input, .lv4-type2-hero input").attr('disabled',true);
            var id = $(this).attr("data-id");
            highwayOfHeroes(id);
        });
        $(".battle-night").click(function () {
            $(this).attr('disabled',true);
            battleNight();
        });
        $(".head-window-btn").click(function () {
            $(this).attr('disabled',true);
            doubleEleven();
        });
        $(".recruit-list-btn").click(function () {
            recruitList();
            openRecruitList();
        });
        $(".hint-window-btn").click(function () {
            $(".hint-window-text").html("");
            $(this).parent().hide();
        });

    });

    function role() {
        var userDataUrl = 'http://act-api.bos.ycgame.com/jiyuanqing/players';
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".login-username").html(data.character);
            $(".lv4-Integral-status1 span").html(data.accuPoint);
            if (data.accuPoint >= 120) {
                $(".lv4-Integral-status1").hide().siblings().show();
            }
            if (data.connect == null){
                $(".reg-success1-link").html("您的角色等级不足30级，未满足该活动要求，无法获取专属链接");
            } else {
                var url = "http://bos.ycgame.com/hd/1811jy/login.html?"+data.connect;
                $(".reg-success1-link").html(url);
            }
            var exchangeLogsArr = Object.keys(data.exchangeLogs).length;
            if (exchangeLogsArr != 0){
                changeTheQuery (data.exchangeLogs);
            }
        }).fail(function (xhr) {
            var markId = sessionStorage.getItem('markId');
            if (!markId){
                userData();
            }else {
                $(".login-username").html(markId);
            }
        })
    }

    function changeTheQuery (obj){
        Object.keys(obj).forEach(function (key) {
            $.each(obj[key],function (index,value) {
                if (key == 1 && value.type == "hero"){
                    var num = index + 1;
                    $(".lv"+ key +"-type1-hero input").hide();
                    $(".lv"+ key +"-type1-hero input[data-id="+value.exchange_id+"]").show().addClass('active');
                }
                if (key == 1 && value.type == "skin"){
                    $(".lv"+ key +"-type2-hero input").hide();
                    $(".lv"+ key +"-type2-hero input[data-id="+value.exchange_id+"]").show().addClass('active');
                }
                if (key == 3 && value.type == "hero"){
                    $(".lv"+ key +"-type1-hero input").hide();
                    $(".lv"+ key +"-type1-hero input[data-id="+value.exchange_id+"]").show().addClass('active');
                }
                if (key == 4 && value.type == "60"){
                    var num = index + 1;
                    $(".lv"+ key +"-type1-hero input").hide();
                    $(".lv"+ key +"-type1-hero input[data-id="+value.exchange_id+"]").show().addClass('active');
                }
                if (key == 4 && value.type == "120"){
                    var num = index + 1;
                    $(".lv"+ key +"-type2-hero input").hide();
                    $(".lv"+ key +"-type2-hero input[data-id="+value.exchange_id+"]").show().addClass('active');
                }
            })
        })
    }

    function userData(){
        open();
        var developmentUrl = "http://act-api.bos.ycgame.com/games/characters";
        var userDataUrl = 'https://act-api.bos.ycgame.com/game/characters';
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $.each(data.data,function (index,value) {
                if (value.id == "ces3" && value.characters.length != 0){
                    $.each(value.characters,function (index,value) {
                        $(".username-user").append("<p data-id="+ value.dbid +" data-lv="+ value.level +">"+ value.name +"</p>");
                    })
                } else if (value.id == "ces3" && value.characters.length == 0) {
                    $(".hint-window").fadeIn("fast",function () {
                        $(".hint-window-text").html("您在游戏里尚未创建角色，请前往游戏里创建角色后再重试！")
                    });
                    $(".login-out").click();
                    return false;
                }

            });
            $(".username-user p").click(function () {
                $(".login-username").html($(this).html());
                var dbid = $(this).attr("data-id");
                var level = $(this).attr("data-lv");
                if (level < 30){
                    $(".reg-success1-link").html("您的角色等级不足30级，未满足该活动要求，无法获取专属链接");
                }
                electUser(dbid);
                sessionStorage.setItem('markId',$(this).html());
                location.reload();
            })
        })
    }

    function electUser (id){
        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/jiyuanqing/choose-character",
            data:{"dbid":id,"area":"ces3"},
            xhrFields: {
                withCredentials: true
            }
        })
    }

    // 导航
    // $(window).bind("scroll",function () {
    //     var top = $(this).scrollTop();
    //     if (top >= 650){
    //         $(".main-nav").addClass('active');
    //     }else {
    //         $(".main-nav").removeClass('active');
    //     }
    // });
    $(".main-nav1").click(function () {
        $("html,body").animate({
            scrollTop:"3899px"
        },"fast")
    });
    $(".main-nav2").click(function () {
        $("html,body").animate({
            scrollTop:"3142px"
        },"fast")
    });
    $(".main-nav3").click(function () {
        $("html,body").animate({
            scrollTop:"650px"
        },"fast")
    });
    $(".main-nav4").click(function () {
        $("html,body").animate({
            scrollTop:"1850px"
        },"fast")
    });
    $(".main-nav5").click(function () {
        $("html,body").animate({
            scrollTop:"5038px"
        },"fast")
    });
    

    // 英雄招募令&战斗赢武将
    function heroEnlist(id) {
        var url = "http://act-api.bos.ycgame.com/jiyuanqing/zhaomuling/exchange_hero/"+ id;
        $.ajax({
            type: "POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".hint-window").fadeIn("fast",function () {
                $(".hint-window-text").html("领取成功！")
            });
            $(".lv1-type1-hero input").removeAttr('disabled');
            location.reload();
        }).fail(function (xhr) {
            if (xhr.responseJSON.code == "no chance") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您的账号不是受邀者，没有领取机会！")
                });
                $(".lv1-type1-hero input").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您的账号已经领取过了！")
                });
                $(".lv1-type1-hero input").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "level less than 50") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您的角色等级未达到50级，请满足要求后再重试！")
                });
                $(".lv1-type1-hero input").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "refresh") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("领取失败，请刷新页面重新领取！")
                });
                $(".lv1-type1-hero input").removeAttr('disabled');
            }
        })
    }

    function skinEnlist(id) {
        var url = "http://act-api.bos.ycgame.com/jiyuanqing/zhaomuling/exchange_skin/"+ id;
        $.ajax({
            type: "POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".hint-window").fadeIn("fast",function () {
                $(".hint-window-text").html("领取成功！")
            });
            $(".lv1-type2-hero input").removeAttr('disabled');
            location.reload();
        }).fail(function (xhr) {
            if (xhr.responseJSON.code == "no chance") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您邀请的成员尚未达到50级，您没有领取机会！")
                });
                $(".lv1-type2-hero input").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您的账号已经领取过了！")
                });
                $(".lv1-type2-hero input").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "refresh") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("领取失败，请刷新页面重新领取！")
                });
                $(".lv1-type2-hero input").removeAttr('disabled');
            }
        })
    }

    // 武将&皮肤打折
    var swiper = new Swiper('.swiper-container', {
        // autoplay: 5000,//可选选项，自动滑动
        prevButton:'.swiper-button-prev',
        nextButton:'.swiper-button-next',
        pagination : '.swiper-pagination',
        paginationClickable :true,
    });
    
    // 战斗赢武将
    function accomplishDay() {
        var url = "http://act-api.bos.ycgame.com/jiyuanqing/fights/logs";
        $.ajax({
            type: "GET",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {

            var codeArr = Object.keys(data.code);
            // if (data.code == "complete") {
            //     $(".lv3-day li").addClass('active');
            //     return false;
            // }else {
            //     var codeArr = Object.keys(data.code);
            //     if (codeArr.length == 10){
            //         $(".lv3-day li").addClass('active');
            //         return false;
            //     }else {
            //         for (var i = 1; i < codeArr.length;i++){
            //             $(".lv3-day li").eq(i).addClass('active');
            //         }
            //     }
            //
            // }


            if (data.code == "complete") {
                $(".lv3-day li").addClass('active');
                return false;
            } else if (codeArr.length == 1){
                $(".lv3-day1").addClass('active');
                return false;
            } else if (codeArr.length == 2){
                $(".lv3-day1, .lv3-day2").addClass('active');
                return false;
            } else if (codeArr.length == 3){
                $(".lv3-day1, .lv3-day2, .lv3-day3").addClass('active');
                return false;
            } else if (codeArr.length == 4){
                $(".lv3-day1, .lv3-day2, .lv3-day3, .lv3-day4").addClass('active');
                return false;
            } else if (codeArr.length == 5){
                $(".lv3-day1, .lv3-day2, .lv3-day3, .lv3-day4, .lv3-day5").addClass('active');
                return false;
            } else if (codeArr.length == 6){
                $(".lv3-day1, .lv3-day2, .lv3-day3, .lv3-day4, .lv3-day5, .lv3-day6").addClass('active');
                return false;
            } else if (codeArr.length == 7){
                $(".lv3-day1, .lv3-day2, .lv3-day3, .lv3-day4, .lv3-day5, .lv3-day6, .lv3-day7").addClass('active');
                return false;
            } else if (codeArr.length == 8){
                $(".lv3-day1, .lv3-day2, .lv3-day3, .lv3-day4, .lv3-day5, .lv3-day6, .lv3-day7, .lv3-day8").addClass('active');
                return false;
            } else if (codeArr.length == 9){
                $(".lv3-day1, .lv3-day2, .lv3-day3, .lv3-day4, .lv3-day5, .lv3-day6, .lv3-day7, .lv3-day8, .lv3-day9").addClass('active');
                return false;
            } else if (codeArr.length == 10){
                $(".lv3-day li").addClass('active');
                return false;
            }
        }).fail(function (xhr) {

        })
    }
    function accomplishHero(id) {
        var url = "http://act-api.bos.ycgame.com/jiyuanqing/fights/exchange_hero/"+ id;
        $.ajax({
            type: "POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".hint-window").fadeIn("fast",function () {
                $(".hint-window-text").html("领取成功！")
            });
            $(".lv3-type1-hero input").removeAttr('disabled');
            location.reload();
        }).fail(function (xhr) {
            if (xhr.responseJSON.code == "no chance") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您尚未完成任务，请完成任务后再来！")
                });
                $(".lv3-type1-hero input").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您的账号已经领取过了！")
                });
                $(".lv3-type1-hero input").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "refresh") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("领取失败，请刷新页面重新领取！")
                });
                $(".lv3-type1-hero input").removeAttr('disabled');
            }
        })
    }
    // 英雄之路
    function highwayOfHeroes(id) {
        var url = "http://act-api.bos.ycgame.com/jiyuanqing/hero_road/exchange/" + id;
        $.ajax({
            type:"POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".hint-window").fadeIn("fast",function () {
                $(".hint-window-text").html("兑换成功！")
            });
            $(".lv4-type1-hero input, .lv4-type2-hero input").removeAttr('disabled');
            memberPoints();
            location.reload();
        }).fail(function (xhr) {
            if (xhr.responseJSON.code == "less point") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("积分不足，无法兑换！")
                });
                $(".lv4-type1-hero input, .lv4-type2-hero input").removeAttr('disabled');
                memberPoints()
            }else if (xhr.responseJSON.code == "has"){
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您已兑换过了！")
                });
                $(".lv4-type1-hero input, .lv4-type2-hero input").removeAttr('disabled');
                memberPoints()
            } else if (xhr.responseJSON.code == "refresh"){
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("领取失败，请刷新页面重新领取！")
                });
                $(".lv4-type1-hero input, .lv4-type2-hero input").removeAttr('disabled');
                memberPoints()
            }
        })
    }
    function memberPoints() {
        var userDataUrl = 'http://act-api.bos.ycgame.com/jiyuanqing/players';
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".lv4-Integral-status1 span").html(data.accuPoint);
        })
    }
    
    
    // 战斗赢配饰
    function battleNight() {
        var url = "http://act-api.bos.ycgame.com/jiyuanqing/battle-night/exchange";
        $.ajax({
            type:"POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".hint-window").fadeIn("fast",function () {
                $(".hint-window-text").html("兑换成功！")
            });
            $(".battle-night").removeAttr('disabled');
        }).fail(function (xhr) {
            if (xhr.responseJSON.code == "no chance") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您的角色尚未满足要求，无法兑换！")
                });
                $(".battle-night").removeAttr('disabled');
            }else if (xhr.responseJSON.code == "has"){
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您已兑换过了！")
                });
                $(".battle-night").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "refresh"){
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("领取失败，请刷新页面重新领取！")
                });
                $(".battle-night").removeAttr('disabled');
            } else if (xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("活动尚未开始！")
                });
                $(".battle-night").removeAttr('disabled');
            } else if (xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("活动已结束！")
                });
                $(".battle-night").removeAttr('disabled');
            }
        })
    }
    
    // 双十一
    function doubleEleven() {
        var url = "http://act-api.bos.ycgame.com/jiyuanqing/double-eleven/exchange";
        $.ajax({
            type:"POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".hint-window").fadeIn("fast",function () {
                $(".hint-window-text").html("兑换成功！")
            });
            $(".head-window-btn").removeAttr('disabled');
        }).fail(function (xhr) {
            if (xhr.responseJSON.code == "noChance") {
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您的角色尚未满足要求，无法兑换！")
                });
                $(".head-window-btn").removeAttr('disabled');
            }else if (xhr.responseJSON.code == "has"){
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("您已兑换过了！")
                });
                $(".head-window-btn").removeAttr('disabled');
            } else if (xhr.responseJSON.code == "refresh"){
                $(".hint-window").fadeIn("fast",function () {
                    $(".hint-window-text").html("领取失败，请刷新页面重新领取！")
                });
                $(".head-window-btn").removeAttr('disabled');
            }
        })
    }
    // 角色选择
    var $user;
    $user = $('.username');
    $user.on('click', '.username-user p', function () {
        close();
    });
    function open(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $user, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });
        $user.data('layer', layerId);
        $user.find('.' + id).show().siblings().hide();

        cb && cb.call($user);
    }
    function close() {
        layer.close($user.data('layer'));
    }

    // 已招募成员
    var $recruitList;
    $recruitList = $('.recruit-list');
    $recruitList.on('click', '.recruit-list-close', function () {
        closeRecruitList();
        $(".recruit-list-user").html("");
    });
    function openRecruitList(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $recruitList, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });
        $recruitList.data('layer', layerId);
        $recruitList.find('.' + id).show().siblings().hide();

        cb && cb.call($recruitList);
    }
    function closeRecruitList() {
        layer.close($recruitList.data('layer'));
    }
    function recruitList() {
        var url = "http://act-api.bos.ycgame.com/jiyuanqing/zhaomuling/members/my-members";
        $.ajax({
            type:"GET",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            if (data.detail == null){
                $(".recruit-list-user").append("<p>您尚未招募到成员！</p>");
            } else {
                $.each(data.detail,function (index,value) {
                    $(".recruit-list-user").append("<p>账号："+value.account+"&nbsp;&nbsp;&nbsp;角色："+value.character+"&nbsp;&nbsp;&nbsp;等级："+value.level+"</p>");
                });
            }
        })
    }
});


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 9
// module chunks = 1